import router from '@/router'
import { vuexLoadingBase } from '@/store/compositionV2/utils/loading'
import { getItem } from '@/api/defaultApi'
import switchCreateOrUpdate from '@/utils/store/switchCreateOrUpdate'
import { mapObject, mapTransport } from '@/utils/page/logistic'
import { createIdRandom } from '@/utils/create'
import { LOGISTIC_WAYBILL_URL } from '@/api/Logistic'

const initialState = () => {
  return {
    urlApi: LOGISTIC_WAYBILL_URL,
    id: null,
    waybill: {
      date_at: '',
      code: '',
      waybill: '',
      driver: null,
      transport: null,
      distance_start: '',
      distance_end: '',
      distance_set: 'Введите корректные данные',
      start_at: null,
      end_at: null,
      fuel_balance: []
    },

    work: [],
    workTableHeader: {
      allActive: false,
      headers: [
        {
          title: 'Объект',
          isSortable: false
        },
        {
          title: 'ФИО Мастера',
          isSortable: false
        },
        {
          title: 'Ответственный',
          isSortable: false
        },
        {
          title: 'Количество времени',
          isSortable: false
        },
        {
          title: 'Тип рабочего времени',
          isSortable: false
        }
      ]
    },
    workModal: {
      active: false,
      updatedId: null,
      object: null,
      amount_of_time: null,
      description: null,
      responsible: null,
      type_of_working_time: null,
      validation: {
        amount_of_time: {
          type: null,
          message: ''
        }
      }
    },
    workIsActiveDelete: false,

    validation: {
      date_at: {
        type: null,
        message: ''
      },
      start_at: {
        type: null,
        message: ''
      },
      end_at: {
        type: null,
        message: ''
      },
      code: {
        type: null,
        message: ''
      }
    },
    isLoading: false,

    params: {
      expand: 'driver,transport,work,fuel_balance'
    }
  }
}

const state = initialState

const getters = {
  waybillDriverTransports: state => {
    return state.waybill?.driver?.transport?.map(mapTransport) || false
  },
  getWaybillUpdateWork: state => state.work.map(e => {
    return {
      isActive: e.isActive,
      id: e.id,
      values: [
        e.object ? e.object.name : '',
        e.responsible ? e.responsible : '',
        e.object ? e.object?.master : '',
        e.amount_of_time ? e.amount_of_time : '',
        e.type_of_working_time === 1 ? 'Обычный рабочий день' : e.type_of_working_time === 2 ? 'Выходной или праздничный день' : e.type_of_working_time === 3 ? 'Командировка' : ''
      ]
    }
  })
}

const mutations = {
  SET_WAYBILL_UPDATE: (state, waybill) => {
    state.waybill = {
      id: waybill.id,
      date_at: waybill.date_at,
      driver: waybill.driver,
      transport: { name: `${waybill.transport.name} ${waybill.transport.number}`, id: waybill.transport.id },
      distance_start: waybill.distance_start ? waybill.distance_start : '',
      distance_end: waybill.distance_end ? waybill.distance_end : '',
      start_at: waybill.start_at ? waybill.start_at : '',
      end_at: waybill.end_at ? waybill.end_at : '',
      code: waybill.code,
      distance_set: waybill.distance_set,
      fuel_balance: waybill.fuel_balance ? waybill.fuel_balance.map(e => {
        return {
          id: e.id,
          name: e.fuel ? e.fuel.name : '',
          balance_at: e.balance_at,
          balance_add: e.balance_add,
          balance_to: e.balance_to,
          fuel_id: e.fuel_id ? e.fuel_id : ''
        }
      }) : []
    }

    state.work = waybill.work ? waybill.work.map(e => {
      return {
        ...e,
        object_id: e.object ? e.object.id : null,
        object_select: e.object ? { name: `${e.object.code} (${e.object.name})` } : null,
        type_of_working_time: e.type_of_working_time ? e.type_of_working_time : null
      }
    }) : []

    state.id = waybill.id
  },
  SET_WAYBILL_UPDATE_INITIAL_STATE: (state) => {
    Object.assign(state, initialState())
  },

  SET_WAYBILL_UPDATE_DATE_AT: (state, value) => {
    state.waybill.date_at = value
  },
  SET_WAYBILL_UPDATE_CODE: (state, value) => {
    state.waybill.code = value
  },
  SET_WAYBILL_UPDATE_DISTANCE_START: (state, value) => {
    state.waybill.distance_start = value
  },
  SET_WAYBILL_UPDATE_DISTANCE_END: (state, value) => {
    state.waybill.distance_end = value
  },
  SET_WAYBILL_UPDATE_DISTANCE_SET: (state) => {
    const distanceAt = state.waybill.distance_start
    const distanceTo = state.waybill.distance_end
    let result

    if (checkNumber(distanceAt) && checkNumber(distanceTo)) {
      result = Number(distanceTo) - Number(distanceAt)

      // eslint-disable-next-line eqeqeq
      result = (result == 0) ? 'Машина простаивала' : result
      result = (result < 0) ? 'Некорректные данные, конечная дистанция меньше стартовой' : result
    } else {
      result = ' Введите корректные данные'
    }

    function checkNumber (value) {
      const result = value.match(/^[0-9]+$/g)
      return !!((result !== null && result.length))
    }

    state.waybill.distance_set = result
  },
  SET_WAYBILL_UPDATE_START_AT: (state, value) => {
    state.waybill.start_at = value
  },
  SET_WAYBILL_UPDATE_END_AT: (state, value) => {
    state.waybill.end_at = value
  },
  SET_WAYBILL_UPDATE_DRIVER: (state, value) => {
    state.waybill.driver = value

    if (value?.default_car) {
      state.waybill.transport = mapTransport(value.default_car)
    } else {
      state.waybill.transport = null
    }
  },
  SET_WAYBILL_UPDATE_TRANSPORT: (state, value) => {
    state.waybill.transport = value
    state.waybill.fuel_balance = []
  },
  RESET_WAYBILL_UPDATE_FUEL_BALANCE: (state) => {
    state.waybill.fuel_balance = []
  },

  SET_WAYBILL_UPDATE_VALIDATION: (state, valid) => {
    if (valid.date_at) {
      state.validation.date_at.message = valid.date_at[0]
      state.validation.date_at.type = 'error'
    }
    if (valid.start_at) {
      state.validation.start_at.message = valid.start_at[0]
      state.validation.start_at.type = 'error'
    }
    if (valid.end_at) {
      state.validation.end_at.message = valid.end_at[0]
      state.validation.end_at.type = 'error'
    }
    if (valid.code) {
      state.validation.code.message = valid.code[0]
      state.validation.code.type = 'error'
    }
    if (valid.transport_id) {
      state.validation.transport.message = valid.transport_id[0]
      state.validation.transport.type = 'error'
    }
    if (valid.driver_id) {
      state.validation.driver.message = valid.driver_id[0]
      state.validation.driver.type = 'error'
    }
  },
  CLEAR_WAYBILL_UPDATE_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'date_at':
        state.validation.date_at = {
          type: null,
          message: ''
        }
        break
      case 'code':
        state.validation.code = {
          type: null,
          message: ''
        }
        break
      case 'amount_of_time':
        state.workModal.validation.amount_of_time = {
          type: null,
          message: ''
        }
        break
      case 'start_at':
        state.validation.start_at = {
          type: null,
          message: ''
        }
        break
      case 'end_at':
        state.validation.end_at = {
          type: null,
          message: ''
        }
        break
      case 'driver':
        state.validation.driver = {
          type: null,
          message: ''
        }
        break
      case 'transport':
        state.validation.transport = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },

  SET_WAYBILL_UPDATE_WORK_TIME: (state, value) => {
    value = value.replace(/,/, '.')
    state.workModal.amount_of_time = value
  },
  SET_WAYBILL_UPDATE_WORK_RESPONSIBLE: (state, value) => {
    state.workModal.responsible = value
  },
  SET_WAYBILL_UPDATE_WORK_DESCRIPTION: (state, value) => {
    state.workModal.description = value
  },
  SET_WAYBILL_UPDATE_WORK_TYPE: (state, value) => {
    state.workModal.type_of_working_time = value
  },
  OPEN_WAYBILL_UPDATE_WORK_MODAL: (state, itemId) => {
    const modal = state.workModal
    modal.active = true

    if (itemId) {
      const selectedWork = state.work.filter(fuel => {
        return fuel.id === itemId
      }).pop()

      modal.updatedId = itemId
      modal.object = selectedWork.object && mapObject(selectedWork.object)
      modal.amount_of_time = selectedWork.amount_of_time
      modal.description = selectedWork.description
      modal.responsible = selectedWork.responsible
      modal.type_of_working_time = selectedWork.type_of_working_time
    }
  },
  CLOSE_WAYBILL_UPDATE_WORK_MODAL: (state) => {
    state.workModal = {
      active: false,
      updatedId: null,
      object: null,
      amount_of_time: null,
      description: null,
      responsible: null,
      type_of_working_time: null,
      validation: {
        amount_of_time: {
          type: null,
          message: ''
        }
      }
    }
  },
  SAVE_WAYBILL_UPDATE_WORK_MODAL: (state) => {
    const modal = state.workModal

    if (!modal.amount_of_time) {
      modal.validation.amount_of_time = {
        type: 'error',
        message: 'Необходимо для заполнения'
      }
      return
    }

    if (modal.updatedId) {
      const item = state.work[state.work.findIndex(e => e.id === modal.updatedId)]

      item.amount_of_time = modal.amount_of_time
      item.object_id = modal.object ? modal.object.id : null
      item.object = modal.object || null
      item.responsible = modal.responsible
      item.description = modal.description
      item.type_of_working_time = modal.type_of_working_time
      item.id = modal.updatedId
    } else {
      state.work.push({
        isActive: false,
        amount_of_time: modal.amount_of_time,
        object_id: modal.object ? modal.object.id : null,
        object: modal.object || null,
        object_select: modal.object || null,
        responsible: modal.responsible,
        description: modal.description,
        type_of_working_time: modal.type_of_working_time,
        newWork: true,
        ...createIdRandom()
      })
    }

    state.workModal = {
      active: false,
      updatedId: null,
      object: null,
      amount_of_time: null,
      description: null,
      responsible: null,
      type_of_working_time: null,
      validation: {
        amount_of_time: {
          type: null,
          message: ''
        }
      }
    }
  },

  TOGGLE_WAYBILL_UPDATE_CHECK_WORK_ITEM: (state, itemId) => {
    const itemsLength = state.work.length
    let counter = 0

    state.work.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.workIsActiveDelete = true : state.workIsActiveDelete = false

    state.workTableHeader.allActive = counter === itemsLength
  },
  TOGGLE_WAYBILL_UPDATE_WORK_ACTIVE_ALL: (state) => {
    state.workTableHeader.allActive = !state.workTableHeader.allActive
    state.workTableHeader.allActive ? state.workIsActiveDelete = true : state.workIsActiveDelete = false

    state.work.forEach((elem) => {
      elem.isActive = state.workTableHeader.allActive
    })
  },
  DELETE_WAYBILL_UPDATE_WORK_ITEMS: (state) => {
    state.work = state.work.filter(e => {
      return !e.isActive
    })
    state.workTableHeader.allActive = false
    state.workIsActiveDelete = false
  },

  SET_WAYBILL_UPDATE_FUEL: (state, fuels) => {
    state.waybill.fuel_balance = fuels.map(e => {
      return {
        ...e,
        balance_add: '0',
        balance_at: '0',
        balance_to: '0'
      }
    })
  },
  SET_WAYBILL_UPDATE_BALANCE_ADD: (state, payload) => {
    const item = state.waybill.fuel_balance.find(e => e.id === payload.id)
    item.balance_add = payload.value
  },
  SET_WAYBILL_UPDATE_BALANCE_AT: (state, payload) => {
    const item = state.waybill.fuel_balance.find(e => e.id === payload.id)
    item.balance_at = payload.value
  },
  SET_WAYBILL_UPDATE_BALANCE_TO: (state, payload) => {
    const item = state.waybill.fuel_balance.find(e => e.id === payload.id)
    item.balance_to = payload.value
  },
  ...vuexLoadingBase.createMutations()
}

const actions = {
  getWaybillUpdate ({ commit, state }, id) {
    commit('SET_IS_LOADING', true)
    return getItem(state.urlApi, id, state.params)
      .then(response => {
        commit('SET_WAYBILL_UPDATE', response.data.data)
      })
      .catch(error => {
        console.log(error)
        console.log('ошибка получения путевого листа', error.response)
      })
      .finally(() => commit('SET_IS_LOADING', false))
  },

  saveWaybillUpdate ({ commit, state }) {
    const wData = state.waybill

    const data = {
      date_at: wData.date_at,
      code: wData.code,
      driver_id: wData.driver ? wData.driver.id : null,
      transport_id: wData.transport ? wData.transport.id : null,
      distance_start: wData.distance_start ? wData.distance_start : null,
      distance_end: wData.distance_end ? wData.distance_end : null,
      distance_set: wData.distance_set ? wData.distance_set : null,
      fuel_balance: wData.fuel_balance.length ? wData.fuel_balance.map(e => {
        return {
          ...e,
          fuel_id: e.pivot ? e.pivot.fuel_id : e.fuel_id
        }
      }) : null,
      start_at: wData.start_at ? wData.start_at : null,
      end_at: wData.end_at ? wData.end_at : null,
      work: state.work.length ? state.work.map(e => {
        return {
          amount_of_time: e.amount_of_time,
          description: e.description ? e.description : null,
          responsible: e.responsible ? e.responsible : null,
          object_id: e.object_id ? e.object_id : null,
          type_of_working_time: e.type_of_working_time ? e.type_of_working_time : null
        }
      }) : null
    }

    switchCreateOrUpdate(state.urlApi, state.id, data, state.params)
      .then(() => {
        router.push({ name: 'LogisticWaybillList' })
      })
      .catch(error => {
        console.log('Ошибка обновления объекта', error.response)
        commit('SET_WAYBILL_UPDATE_VALIDATION', error.response.data.validation)
      })
  },

  setWaybillUpdateDriver ({ commit, state }, value) {
    commit('RESET_WAYBILL_UPDATE_FUEL_BALANCE')
    commit('SET_WAYBILL_UPDATE_DRIVER', value)

    if (!value?.default_car_id) return

    getItem('logistics-transport', value.default_car_id, { expand: 'drivers,waybills,fuel,scans' })
      .then(response => {
        if (response.data.data.fuel) {
          commit('SET_WAYBILL_UPDATE_FUEL', response.data.data.fuel)
        }
      }).catch(error => {
        console.log(error.response)
      })
  },
  setWaybillUpdateTransport ({ commit, state }, value) {
    commit('RESET_WAYBILL_UPDATE_FUEL_BALANCE')
    commit('SET_WAYBILL_UPDATE_TRANSPORT', value)
    if (!value?.id) return

    getItem('logistics-transport', value.id, { expand: 'drivers,waybills,fuel,scans' })
      .then(response => {
        if (response.data.data.fuel) {
          commit('SET_WAYBILL_UPDATE_FUEL', response.data.data.fuel)
        }
      }).catch(error => {
        console.log(error.response)
      })
  },

  setWaybillUpdateDistanceStart ({ commit }, value) {
    commit('SET_WAYBILL_UPDATE_DISTANCE_START', value)
    commit('SET_WAYBILL_UPDATE_DISTANCE_SET')
  },
  setWaybillUpdateDistanceEnd ({ commit }, value) {
    commit('SET_WAYBILL_UPDATE_DISTANCE_END', value)
    commit('SET_WAYBILL_UPDATE_DISTANCE_SET')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
